<template>
  <div id="app">
    <ee-navbar></ee-navbar>
    <router-view></router-view>
    <ee-footer></ee-footer>
    <ee-offcanvas-menu></ee-offcanvas-menu>
  </div>
</template>

<script>
import NavBar from '@/components/shared/NavBar'
import Footer from '@/components/shared/Footer'
import OffcanvasMenu from '@/components/shared/OffcanvasMenu'

export default {
  name: 'app',
  components: {
    'ee-navbar': NavBar,
    'ee-footer': Footer,
    'ee-offcanvas-menu': OffcanvasMenu
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

/* body,
html {
  height: 100%;
} */

html {
  background-color: #000;
  /* background-color: #2a144c;
  background: url("./assets/purple-back-gr.png") repeat-y center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover; */
}

h1 {
  font-family: 'Orbitron', sans-serif;
  font-weight: 800;
  text-shadow: 0px 2px 10px #000000;
}

.mint {
  color: #55d6be;
}

.patua-one {
  font-family: "Patua One", serif;
}

.ee-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.section-title {
  font-size: 2.5em;
  font-weight: 700;
}

.purpleBackgroundImage {
  background-image: url(./assets/purple-back-gr.png);
}

@media screen and (max-width: 640px) {
  .section-title {
    font-size: 1.5em;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue